import { useAtom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import type { SaveScriptDto } from '../script/script.dto';

const videoAnalysisAtom = atomWithReset<SaveScriptDto | null>(null);

export function useVideoAnalysisPageData() {
  return useAtom(videoAnalysisAtom);
}
